<div class="header">
  <div class="left-header">
    @if (isClosed) {
      <app-dealer-select class="dealer-select" />
    }
    <app-breadcrumb />
  </div>
  <div class="right-header">
    @if (!hideReportsLink) {
      <img
        class="right-header-icon"
        src="assets/images/report-download.svg"
        alt="download reports"
        title="Download Reports"
        (click)="goToReports()"
      />
    }
    <div (click)="openComments()" class="comments-icon-container">
      <img
        class="right-header-icon"
        src="assets/images/comments.svg"
        alt="messages"
        title="Messages"
        style="cursor: pointer"
      />
      @if (unreadCount) {
        <span class="unread-badge">{{ unreadCount }}</span>
      }
    </div>

    <div (click)="openNotification()" class="notification-icon-container">
      <img
        class="right-header-icon"
        src="assets/images/notification.svg"
        alt="notifications"
        title="Notifications"
      />
      @if (unreadNotificationsCount) {
        <span class="unread-badge">{{ unreadNotificationsCount }}</span>
      }
    </div>
    <!-- Avatar with toggle -->
    <div class="avatar-container" style="position: relative">
      <img
        class="right-header-icon"
        src="assets/images/avatar.svg"
        alt="user avatar"
        [title]="userName || 'User Avatar'"
        (click)="toggleLogoutMenu()"
        style="cursor: pointer"
      />
      <!-- Logout dropdown -->
      @if (showLogoutMenu) {
        <div class="logout-dropdown">
          <a (click)="logout()">Logout</a>
        </div>
      }
    </div>
  </div>
</div>
